import React from 'react'
import classNames from 'classnames'
import ActionBoxRowItem from './components/ActionBoxRowItem'
import ShowAll from '../ShowAll/ShowAll'
import './style.scss'

const ActionBoxRow = ({ rows, rowClick, cellDefs, action, color, isCard, hasBackground, isDisabled, showAll, hoverActions, isExpanded, expandedActions, isSelected }) => {

  const backgroundContent = (
    <div className={classNames(
      hasBackground && 'viso-action-box-row__background'
    )}>
      {rows.map((row, index) => (
        <ActionBoxRowItem
          cellDefs={cellDefs}
          action={action}
          color={color}
          key={index}
          row={row}
          hoverActions={hoverActions}
          isDisabled={isDisabled ? isDisabled(row) : false}
          isLastRow={index === rows.length - 1}
          isExpanded={isExpanded && isExpanded(row)}
          isSelected={isSelected && isSelected(row)}
          rowClick={rowClick}
          expandedActions={expandedActions}
        />
      ))}
    </div>
  )

  return (
    <div className={classNames(
      'viso-action-box-row',
      isCard && 'viso-action-box-row--card'
    )}>
      {showAll ?
        <ShowAll height={((showAll + 1) * 61) - 30}>
          {backgroundContent}
        </ShowAll>
        :
        backgroundContent
      }
    </div>
  )
}

export default ActionBoxRow